import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'editor:tool': () => import('./components/tool'),
        'directive:igenflow': () => import('./components/html/igenflow'),
        'activate:editor': () => import('./components/activate'),
    },
});
